<ng-container *ngIf="isLoading; else content">
    <vpg-three-dots-loader [screenReaderText]="'Loading'"></vpg-three-dots-loader>
</ng-container>
<ng-template #content>
    <div class="ip-coverage-heading">
        <h3 class="h3 ip-coverage-title">{{ 'Coverage' | translate }}</h3>
        <vpg-dropdown-next
            *ngIf="isMedicalIndividualFamilyPlan && !hasError"
            [id]="'insurance-plan-coverage-network-dropdown'"
            class="ip-coverage-dropdown"
            [(ngModel)]="currentNetwork"
            (valueChange)="dropdownChangeListener()"
            [options]="coverageNetworkOptions">
        </vpg-dropdown-next>
    </div>
    <tiered-coverage
        *ngIf="isTierredPlan && !accumulatorData.length && networkFilter === CoverageNetworkTypeEnum.InNetwork"
        [insurancePlanCoverages]="insurancePlanCoverages"
    ></tiered-coverage>
    <ng-container *ngIf="hasError">
        <div
            *ngIf="!showLearnMore"
            class="ip-coverage-error">
            <h3 class="ip-coverage-error-header h4">{{ 'UnableToLoadData' | translate }}</h3>
            <p class="ip-coverage-error-message body-regular">{{ 'TryRefreshingScreen' | translate }}</p>
        </div>
        <insurance-plan-learn-more
            *ngIf="showLearnMore"
            (openConsentModalChange)="openConsentModalChange.emit($event)"
        ></insurance-plan-learn-more>
    </ng-container>
    <div *ngIf="isMedicalIndividualFamilyPlan && !hasError">
        <div *ngIf="!accumulatorsState">
            <div class="ip-coverage-amounts">
                <div *ngIf="networkFilter === CoverageNetworkTypeEnum.InNetwork">
                    <coverage-item
                        *ngIf="hasCoverageData.medical.inNetwork.individual"
                        [medicalCoverages]="medicalCoverages.individualCoverage.inNetwork"
                        [coverageTitle]="insurancePlanLevel.Individual"
                        [networkFilter]="networkFilter"
                    ></coverage-item>
                    <coverage-item
                        *ngIf="hasCoverageData.medical.inNetwork.family"
                        [medicalCoverages]="medicalCoverages.familyCoverage.inNetwork"
                        [coverageTitle]="insurancePlanLevel.Family"
                        [networkFilter]="networkFilter"
                    ></coverage-item>
                </div>
                <div *ngIf="networkFilter === CoverageNetworkTypeEnum.OutOfNetwork">
                    <coverage-item
                        *ngIf="hasCoverageData.medical.outOfNetwork.individual"
                        [medicalCoverages]="medicalCoverages.individualCoverage.outOfNetwork"
                        [coverageTitle]="insurancePlanLevel.Individual"
                        [networkFilter]="networkFilter"
                    ></coverage-item>
                    <coverage-item
                        *ngIf="hasCoverageData.medical.outOfNetwork.family"
                        [medicalCoverages]="medicalCoverages.familyCoverage.outOfNetwork"
                        [coverageTitle]="insurancePlanLevel.Family"
                        [networkFilter]="networkFilter"
                    ></coverage-item>
                </div>
            </div>
        </div>
        <div *ngIf="accumulatorsState">
           <accumulators-section
                [insurancePlanAccumulators]="insurancePlanAccumulators"
                [showAccumulator]="showAccumulator"
                [networkFilter]="networkFilter"
            ></accumulators-section>
            <p class="ip-accumulators-last-update">
                {{ 'LastUpdatedColon' | translate }} {{ insurancePlanAccumulators?.lastUpdate | date: constants.DATE_FORMAT }}
            </p>
        </div>
        <insurance-plan-learn-more
            *ngIf="showLearnMore"
            (openConsentModalChange)="openConsentModalChange.emit($event)"
        ></insurance-plan-learn-more>
    </div>
    <div
        *ngIf="isMedicalRBPPlan && !hasError"
        class="ip-coverage-amounts">
        <div *ngIf="!accumulatorsState">
            <div
                *ngIf="hasCoverageData.rbp.individual"
                class="ip-coverage-amount-container">
                <h5 class="h5">{{ insurancePlanLevel.Individual | translate }}</h5>
                <div *ngFor="let coverage of rbpCoverages.individualCoverage">
                    <div
                        class="ip-coverage-amount-item">
                        <p
                            [id]="'rbp-individual-' + coverage.coverage + '-coverage'"
                            class="ip-coverage-amount-item-text body-regular">{{ coverage.coverage | translate }}</p>
                        <p
                            [id]="'rbp-individual-' + coverage.coverage + '-amount'"
                            class="ip-coverage-amount-item-text h5">${{ coverage.amount | number }}</p>
                    </div>
                </div>
            </div>
            <div
                *ngIf="hasCoverageData.rbp.family"
                class="ip-coverage-amount-container">
                <h5 class="h5">{{ insurancePlanLevel.Family | translate }}</h5>
                <div *ngFor="let coverage of rbpCoverages.familyCoverage">
                    <div
                        class="ip-coverage-amount-item">
                        <p
                            [id]="'rbp-family-' + coverage.coverage + '-coverage'"
                            class="ip-coverage-amount-item-text body-regular">{{ coverage.coverage | translate }}</p>
                        <p
                            [id]="'rbp-family-' + coverage.coverage + '-amount'"
                            class="ip-coverage-amount-item-text h5">${{ coverage.amount | number }}</p>
                    </div>
                </div>
            </div>
        </div>
        <accumulators-section
            *ngIf="accumulatorsState"
            [insurancePlanAccumulators]="insurancePlanAccumulators"
            [showAccumulator]="showAccumulator"
            [networkFilter]="networkFilter"
        ></accumulators-section>
        <insurance-plan-learn-more
            *ngIf="showLearnMore"
            (openConsentModalChange)="openConsentModalChange.emit($event)"
        ></insurance-plan-learn-more>
    </div>
    <div
        *ngIf="planType === InsurancePlanTypeEnum.Dental && !hasError && !dentalAccumulators"
        class="ip-coverage-amounts">
        <div
            *ngIf="hasCoverageData.dental.noPlanLevel || hasCoverageData.dental.individual || hasCoverageData.dental.family"
            class="ip-coverage-amount-container">
            <div
                *ngFor="let coverage of dentalCoverages.individualCoverage"
                class="ip-coverage-amount-item">
                <p
                    [id]="constants.INDIVIDUAL_DEDUCTIBLE_DENTAL + '-coverage'"
                    class="ip-coverage-amount-item-text body-regular">{{ constants.INDIVIDUAL_DEDUCTIBLE_DENTAL | translate }}</p>
                <p
                    [id]="constants.INDIVIDUAL_DEDUCTIBLE_DENTAL + '-amount'"
                    class="ip-coverage-amount-item-text h5">${{ coverage.amount | number }}</p>
            </div>
            <div
                *ngFor="let coverage of dentalCoverages.familyCoverage"
                class="ip-coverage-amount-item">
                <p
                    [id]="constants.FAMILY_DEDUCTIBLE_DENTAL + '-coverage'"
                    class="ip-coverage-amount-item-text body-regular">{{ constants.FAMILY_DEDUCTIBLE_DENTAL | translate }}</p>
                <p
                    [id]="constants.FAMILY_DEDUCTIBLE_DENTAL + '-amount'"
                    class="ip-coverage-amount-item-text h5">${{ coverage.amount | number }}</p>
            </div>
            <div
                *ngFor="let coverage of dentalCoverages.noPlanLevelCoverage"
                class="ip-coverage-amount-item">
                <p
                    id="AnnualCoverageLimit-coverage"
                    class="ip-coverage-amount-item-text body-regular">{{ 'AnnualMax' | translate }}</p>
                <p
                    [id]="constants.FAMILY_DEDUCTIBLE_DENTAL + '-amount'"
                    class="ip-coverage-amount-item-text h5">${{ coverage.amount | number }}</p>
            </div>
        </div>
    </div>
    <dental-accumulators
        *ngIf="dentalAccumulators"
        [dentalAccumulators]="insurancePlanAccumulators"
    ></dental-accumulators>
    <div
        *ngIf="planType === InsurancePlanTypeEnum.Vision && !hasError"
        class="ip-coverage-amounts">
        <div
            *ngIf="hasCoverageData.vision.noPlanLevel"
            class="ip-coverage-amount-container">
            <div *ngFor="let coverage of visionCoverages">
                <div class="ip-coverage-amount-item">
                    <p
                        *ngIf="coverage.coverage !== constants.CONTACT_OR_FRAMES_LENSES"
                        [id]="coverage.coverage + '-coverage'"
                        class="ip-coverage-amount-item-text body-regular">{{ coverage.coverage | translate }}</p>
                    <p
                        *ngIf="coverage.coverage === constants.CONTACT_OR_FRAMES_LENSES"
                        [id]="constants.CONTACT_FRAMES_LENSES + '-coverage'"
                        class="ip-coverage-amount-item-text body-regular">{{ constants.CONTACT_FRAMES_LENSES | translate }}</p>
                    <p
                        [id]="coverage.coverage + '-amount'"
                        class="ip-coverage-amount-item-text h5">${{ coverage.amount | number }}</p>
                </div>
            </div>
        </div>
    </div>
</ng-template>
